<template>
    <dropdown :px-width="320">
        <template #button>
            <div class="rounded border border-gray-250 px-3 py-2">
                <span v-if="modelValueIsClassroomStart()">All Time</span>
                <span v-else-if="modelValueIsToday()">Today</span>
                <span v-else
                    >{{
                        dayjs(modelValue)
                            .utc(true)
                            .tz($page.props.display_timezone)
                            .format($page.props.date_formats.short_nice)
                    }}
                </span>
            </div>
        </template>
        <template #content>
            <ul class="py-4">
                <li
                    class="px-6 py-2 text-[15px] hover:cursor-pointer hover:bg-gray-50"
                    @click="newStartDate = classroom.created_at"
                >
                    All Time
                    <span class="text-gray-500"
                        >(since creation of classroom)</span
                    >
                </li>
                <li
                    class="px-6 py-2 text-[15px] hover:cursor-pointer hover:bg-gray-50"
                    @click="newStartDate = dayjs()"
                >
                    Today
                </li>
                <li class="text-[15px] hover:cursor-pointer hover:bg-gray-50">
                    <Datepicker
                        :hide-input-icon="true"
                        :clearable="true"
                        v-model="newStartDate"
                        :enable-time-picker="false"
                        :min-date="
                            dayjs(classroom.created_at).format('YYYY-MM-DD')
                        "
                        :max-date="dayjs().format('YYYY-MM-DD')"
                        format="MM/dd/yyyy"
                        :auto-apply="true"
                    >
                        <template #trigger>
                            <div class="px-6 py-2 text-blue-500">
                                + Select a date
                            </div>
                        </template>
                    </Datepicker>
                </li>
            </ul>
        </template>
    </dropdown>
</template>
<script>
import FormInputDatepicker from "@/Components/FormInputDatepicker";
import Dropdown from "@/Components/Dropdown";
import dayjs from "dayjs";

export default {
    name: "GroupClassroomGoalStartingDateSelector",
    components: { Dropdown, FormInputDatepicker },
    props: {
        goalId: {
            type: Number,
            default: null,
        },
        modelValue: {
            type: [String, Object],
            default: "",
        },
        classroom: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            currentStartDate: this.modelValue,
            newStartDate: null,
        };
    },
    methods: {
        modelValueIsClassroomStart() {
            return (
                dayjs(this.currentStartDate).diff(
                    this.classroom.created_at,
                    "day"
                ) <= 0
            );
        },
        modelValueIsToday() {
            return dayjs(this.currentStartDate).diff(dayjs(), "day") == 0;
        },
        setGoalStart(modelValueDate) {
            let newDate = dayjs(modelValueDate).format("YYYY-MM-DD");
            this.currentStartDate = newDate;
            this.$emit("update:modelValue", newDate);
        },
    },
    watch: {
        newStartDate: {
            handler(newValue, oldValue) {
                this.setGoalStart(newValue);
            },
            deep: false,
        },
    },
};
</script>
